export default __webpack_public_path__ + "static/media/footer.1a41b5dd.png";